import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { KundenGruppesQuerySorterConfig } from 'fa-kt.types';
import { KundenGruppesService } from '../service';

@Component({
  selector: 'fa-kt-kunden-gruppes-sorter',
  templateUrl: './kunden-gruppes-sorter.component.html',
  styleUrls: ['./kunden-gruppes-sorter.component.css'],
})
export class KundenGruppesSorterComponent {
  KundenGruppesSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public kundenGruppes: KundenGruppesService,
  ) {
    this.KundenGruppesSorterConfig = KundenGruppesQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
